var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('div',{staticClass:"passenger-block-container"},[_c('FlashMessage'),_vm._l((_vm.profile.paxnames),function(person,index){return _c('div',{key:index,staticClass:"passenger-block-item"},[_c('Member',{attrs:{"person":person,"person-index":index}})],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }